var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"audio-player"},[(_vm.tarUrl && _vm.tarUrl !== '--')?_c('audio',{attrs:{"id":"app-audio","src":'http://' + _vm.tarUrl},on:{"loadedmetadata":_vm.loadedmetadata,"ended":_vm.ended}}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }